import React from 'react';
import InputMask from 'react-input-mask';
import { cloneDeep } from 'lodash';
import withStyles from 'react-jss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { Translation, Trans } from 'react-i18next';

import {
  getAuthState,
  getEcapState,
  getOnboardingState,
} from '../../store/selectors';
import {
  saveEcap,
  getEcap,
  setEcap,
  insertFeaturesByName,
} from '../../store/actions';
import ComponentHeader from './ComponentHeader';
import { statisticsCopy } from '../../copy/ecap/statisticsCopy.json';
import ToolTipIcon from '../utility/ToolTipIcon';
import SpeechBubble from '../utility/SpeechBubble';
import { handleFireGTM } from '../utility/routeUtil';

const universityName = 'ASU';

const continueButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant ? props.tenant.primary : 'white',
    borderColor: props.tenant ? props.tenant.primary : 'black',

    '&:hover': {
      backgroundColor: 'white',
      border: props.tenant
        ? `2px solid ${props.tenant.primary}`
        : '2px solid black',
      color: props.tenant ? props.tenant.primary : 'black',
      borderStyle: 'solid',
    },
  }),
};

export class AcademicStatistics extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      fall_freshman_gpa: '',
      spring_freshman_gpa: '',
      fall_sophmore_gpa: '',
      spring_sophmore_gpa: '',
      fall_junior_gpa: '',
      spring_junior_gpa: '',
      fall_senior_gpa: '',
      spring_senior_gpa: '',
      cumulative_gpa: '',
      psat: '',
      sat: '',
      act: '',
      class_rank: '',
      student_number: '',
      counselor_name: '',
      parent_name: '',
      counselor_email: '',
      parent_email: '',
      bubbleToShow: null,
      error_psat: '',
      error_sat: '',
      error_act: '',
      error_class_rank: '',
      error_fall_freshman_gpa: '',
      error_spring_freshman_gpa: '',
      error_fall_sophmore_gpa: '',
      error_spring_sophmore_gpa: '',
      error_fall_junior_gpa: '',
      error_spring_junior_gpa: '',
      error_fall_senior_gpa: '',
      error_spring_senior_gpa: '',
      error_cumulative_gpa: '',
      isMobile: false,
    };
  }

  handleClickOutside = (event) => {
    if (event.target.id !== 'external-link') {
      if (!!this.state.bubbleToShow && this._isMounted)
        this.setState({ bubbleToShow: null });
    }
  };

  async componentDidMount() {
    this.setState({
      isMobile: window.innerWidth < 800,
    });
    this._isMounted = true;
    document.addEventListener('mousedown', (e) => {
      this.handleClickOutside(e);
    });
    // We're calling this in other sections of ECAP so I don't think we need it here \
    // but will leave it commented for the PR review in case someone disagrees
    await this.props.getEcap(this.props.auth.jwtToken);

    const plan = this.props.location.pathname.includes('user-profile')
      ? this.props.ecapPlan
      : this.props.ecap.plan;

    this.setState({
      fall_freshman_gpa: plan.fall_freshman_gpa
        ? plan.fall_freshman_gpa.toString()
        : '',
      spring_freshman_gpa: plan.spring_freshman_gpa
        ? plan.spring_freshman_gpa.toString()
        : '',
      fall_sophmore_gpa: plan.fall_sophmore_gpa
        ? plan.fall_sophmore_gpa.toString()
        : '',
      spring_sophmore_gpa: plan.spring_sophmore_gpa
        ? plan.spring_sophmore_gpa.toString()
        : '',
      fall_junior_gpa: plan.fall_junior_gpa
        ? plan.fall_junior_gpa.toString()
        : '',
      spring_junior_gpa: plan.spring_junior_gpa
        ? plan.spring_junior_gpa.toString()
        : '',
      fall_senior_gpa: plan.fall_senior_gpa
        ? plan.fall_senior_gpa.toString()
        : '',
      spring_senior_gpa: plan.spring_senior_gpa
        ? plan.spring_senior_gpa.toString()
        : '',
      cumulative_gpa: plan.cumulative_gpa ? plan.cumulative_gpa.toString() : '',
      psat: plan.psat ? plan.psat.toString() : '',
      sat: plan.sat ? plan.sat.toString() : '',
      act: plan.act ? plan.act.toString() : '',
      class_rank: plan.class_rank ? plan.class_rank.toString() : '',
      student_number: plan.student_number ? plan.student_number : '',
      counselor_name: plan.counselor_name ? plan.counselor_name : '',
      parent_name: plan.parent_name ? plan.parent_name : '',
      counselor_email: plan.counselor_email ? plan.counselor_email : '',
      parent_email: plan.parent_email ? plan.parent_email : '',
    });
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.onRef(undefined);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  getDynamicButton = () => {
    const temporaryValid = true;

    return temporaryValid ? this.props.classes.color : null;
  };

  onInputChange = async (event) => {
    event.persist();

    if (this._isMounted) {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  checkValue = (event, information) => {
    event.persist();
    if (this.state[event.target.id] === '') return;
    if (
      this.state[event.target.id] < information.min ||
      this.state[event.target.id] > information.max
    ) {
      this.setState({
        [event.target.id]: '',
        [`error_${event.target.id}`]: 'Invalid value',
      });
    } else if (
      event.target.id.includes('gpa') &&
      !this.state[event.target.id].toString().split('.')[1]
    ) {
      this.setState((prevState) => ({
        [event.target.id]: parseFloat(
          `${prevState[event.target.id]}.0`
        ).toFixed(1),
      }));
      this.setState({
        [`error_${event.target.id}`]: '',
      });
    } else {
      this.setState({
        [`error_${event.target.id}`]: '',
      });
    }
  };

  handleRoutingGTM = () => {
    handleFireGTM(
      this.props.tenant.name,
      'click "continue" from statistics area',
      this.props.location.pathname
    );
  };

  submitPlan = async () => {
    if (this._isMounted) {
      const plan = this.props.location.pathname.includes('user-profile')
        ? cloneDeep(this.props.ecapPlan)
        : cloneDeep(this.props.ecap.plan);

      const stateArray = [
        'fall_freshman_gpa',
        'spring_freshman_gpa',
        'fall_sophmore_gpa',
        'spring_sophmore_gpa',
        'fall_junior_gpa',
        'spring_junior_gpa',
        'fall_senior_gpa',
        'spring_senior_gpa',
        'cumulative_gpa',
        'psat',
        'sat',
        'act',
        'class_rank',
        'student_number',
        'counselor_name',
        'parent_name',
        'counselor_email',
        'parent_email',
      ];

      stateArray.forEach((key) => {
        plan[key] = this.state[key] || null;
      });

      await this.props.saveEcap(this.props.auth.jwtToken, plan);
    }
  };

  gpaYear = (fallState, springState, year, label) => {
    return (
      <div className={`${year} gpa-year`}>
        <label className="label-gpa" htmlFor={`fall_${year}_gpa`}>
          {label}
        </label>
        <InputMask
          type="text"
          tabIndex={0}
          maskPlaceholder={null}
          mask="9.99"
          onChange={this.onInputChange}
          onBlur={(e) => this.checkValue(e, { min: 0, max: 5 })}
          value={fallState}
          placeholder={i18n.t('Fall', { context: 'Academic Semester' })}
          className="form-statistics"
          aria-label={`fall ${year} GPA`}
          id={`fall_${year}_gpa`}
          disabled={this.props.location.pathname.includes('user-profile')}
        />
        <InputMask
          type="text"
          maskPlaceholder={null}
          mask="9.99"
          tabIndex={0}
          onChange={this.onInputChange}
          value={springState}
          placeholder={i18n.t('Spring', { context: 'Academic Semester' })}
          className="form-statistics"
          onBlur={(e) => this.checkValue(e, { min: 0, max: 5 })}
          aria-label={`spring ${year} GPA`}
          id={`spring_${year}_gpa`}
          disabled={this.props.location.pathname.includes('user-profile')}
        />
        {this.state[`error_fall_${year}_gpa`] ? (
          <p
            aria-live="assertive"
            role="alert"
            aria-atomic="true"
            aria-relevant="text"
            className="score-error"
          >
            {this.state[`error_fall_${year}_gpa`]}
          </p>
        ) : null}
        {this.state[`error_spring_${year}_gpa`] ? (
          <p
            aria-live="assertive"
            role="alert"
            aria-atomic="true"
            aria-relevant="text"
            className="score-error"
          >
            {this.state[`error_spring_${year}_gpa`]}
          </p>
        ) : null}
      </div>
    );
  };

  score = (state, label, testName, placeholder, max, min = 1) => {
    const includeBubble = !!this.getTestBubbleCopy(testName);

    return (
      <div className="score">
        <h2 htmlFor={testName}>
          {label}
          {includeBubble ? (
            <span className="tooltip-margin">
              <span
                role="button"
                aria-label={this.getBubbleAriaLabel(testName)}
                tabIndex={0}
                onClick={() => {
                  this.setState({
                    bubbleToShow: testName,
                  });
                }}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) {
                    this.setState({
                      bubbleToShow: testName,
                    });
                  }
                }}
                onFocus={() => {
                  this.setState({
                    bubbleToShow: testName,
                  });
                }}
              >
                <ToolTipIcon
                  color={this.props.tenant.primary}
                  showToolTip={false}
                />
              </span>
              {this.state.bubbleToShow === testName
                ? this.getSpeechBubble(testName)
                : null}
            </span>
          ) : null}
        </h2>
        <input
          type="text"
          onChange={this.onInputChange}
          value={state}
          mask="9999"
          placeholder={placeholder}
          className="form-statistics"
          aria-label={testName}
          id={testName}
          min={min}
          max={max}
          onBlur={(e) => this.checkValue(e, { min, max })}
          disabled={this.props.location.pathname.includes('user-profile')}
        />
        {this.state[`error_${testName}`] ? (
          <p
            aria-live="assertive"
            role="alert"
            aria-atomic="true"
            aria-relevant="text"
            className="score-error"
          >
            {this.state[`error_${testName}`]}
          </p>
        ) : null}
      </div>
    );
  };

  contactInfo = (state, placeholder, label) => {
    return (
      <input
        type="text"
        onChange={this.onInputChange}
        value={state}
        placeholder={placeholder}
        className="form-statistics"
        aria-label={label}
        id={label}
        disabled={this.props.location.pathname.includes('user-profile')}
      />
    );
  };

  getTestBubbleCopy(testName) {
    const getActSatCopy = (testScoreName, minimumScore, minScoreNonResident) =>
      i18n.t(
        '{{universityName}} requires an {{testScoreName}} score of {{minimumScore}} ({{minScoreNonResident}} for nonresidents).',
        {
          universityName,
          testScoreName: 'ACT',
          minimumScore: '22',
          minScoreNonResident: '24',
        }
      );

    const scoreRequirementsCopy = {
      gpa: i18n.t(
        '{{universityName}} requires a {{testScoreName}} of {{minimumScore}} in competency courses.',
        {
          universityName,
          testScoreName: 'GPA',
          minimumScore: '3.0',
        }
      ),
      class_rank: i18n.t(
        '{{universityName}} requires you to be in the top {{classRankPercentage}} in your high school graduating class.',
        {
          universityName,
          classRankPercentage: '25%',
        }
      ),
      act: getActSatCopy('ACT', '22', '24'),
      sat: getActSatCopy('SAT', '1120', '1180'),
    };

    return scoreRequirementsCopy[testName];
  }

  getBubbleAriaLabel = (scoreName) => {
    return `${this.getTestBubbleCopy(scoreName)} ${i18n.t(
      'Learn more by following the link to {{universityName}} or by contacting your institution of interest.',
      { universityName }
    )}`;
  };

  getSpeechBubble = (scoreName) => {
    /*
    NOTE: the ASU application link (https://admission.asu.edu/first-year/apply) MUST be included in the translation text
    as it is below, not injected dynamically with the interpolation features
    that <Trans> provides, to avoid the forward slashes "/" in the URL appearing
    as escape values in the app. This is due to a limitation and bug with react-i18next
    */

    /* eslint-disable react/jsx-one-expression-per-line */
    const textToDisplay = (
      <>
        {this.getTestBubbleCopy(scoreName)}{' '}
        <Trans>
          Learn more at{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            id="external-link"
            tabIndex={-1}
            href="https://admission.asu.edu/first-year/apply"
          >
            https://admission.asu.edu/first-year/apply
          </a>{' '}
          or your institution of interest.
        </Trans>
      </>
    );

    return this.state.isMobile ? (
      <SpeechBubble
        textToDisplay={textToDisplay}
        bottom="30px"
        right="-37px"
        minHeight="160px"
        height="auto"
        padding="10px"
        width="80px"
        fontSize="8pt"
      />
    ) : (
      <SpeechBubble
        textToDisplay={textToDisplay}
        bottom="30px"
        right="-126px"
        minHeight="120px"
        height="auto"
        padding="10px"
      />
    );
  };

  render() {
    const {
      fall_freshman_gpa,
      spring_freshman_gpa,
      fall_sophmore_gpa,
      spring_sophmore_gpa,
      fall_junior_gpa,
      spring_junior_gpa,
      fall_senior_gpa,
      spring_senior_gpa,
      cumulative_gpa,
      psat,
      sat,
      act,
      class_rank,
      student_number,
      counselor_name,
      parent_name,
      counselor_email,
      parent_email,
    } = this.state;
    const { primary } = this.props.tenant;
    const primaryColor = {
      color: `${primary}`,
    };

    return (
      <Translation>
        {(t) => (
          <div
            id="academic-statistics"
            className={
              this.props.location.pathname.includes('user-profile')
                ? 'academic-statistics-user-profile-container'
                : 'academic-statistics-container'
            }
          >
            <ComponentHeader
              parent="ecap"
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('Academic Statistics')
                  : t('What Are Your Academic Statistics')
              }
              subheadingText={t(
                'Please list your final cumulative statistics that you have earned throughout your high school experience.'
              )}
              tenant={this.props.tenant}
              marginTop="0px"
              appendText="academicStatistics"
            />
            <div className="statistics-section">
              <h2 className="header-gpa gpa">
                {t('Yearly GPA', { context: 'Academic' })}
              </h2>
              <div className="gpa-container">
                <div className="left-years">
                  {this.gpaYear(
                    fall_freshman_gpa,
                    spring_freshman_gpa,
                    'freshman',
                    t('Freshman', { context: 'Academic' })
                  )}
                  {this.gpaYear(
                    fall_sophmore_gpa,
                    spring_sophmore_gpa,
                    'sophmore',
                    t('Sophomore', { context: 'Academic' })
                  )}
                </div>
                <div className="right-years">
                  {this.gpaYear(
                    fall_junior_gpa,
                    spring_junior_gpa,
                    'junior',
                    t('Junior', { context: 'Academic' })
                  )}
                  {this.gpaYear(
                    fall_senior_gpa,
                    spring_senior_gpa,
                    'senior',
                    t('Senior', { context: 'Academic' })
                  )}
                </div>
              </div>
            </div>
            <div className="statistics-section">
              <h2 className="header-gpa">
                {t('Cumulative GPA', { context: 'Academic' })}
                <span className="tooltip-margin">
                  <span
                    role="button"
                    tabIndex={0}
                    aria-label={this.getBubbleAriaLabel('gpa')}
                    onClick={() => {
                      this.setState({
                        bubbleToShow: 'gpa',
                      });
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) {
                        this.setState({
                          bubbleToShow: 'gpa',
                        });
                      }
                    }}
                    onFocus={() => {
                      this.setState({
                        bubbleToShow: 'gpa',
                      });
                    }}
                  >
                    <ToolTipIcon
                      color={this.props.tenant.primary}
                      showToolTip={false}
                    />
                  </span>
                  {this.state.bubbleToShow === 'gpa'
                    ? this.getSpeechBubble('gpa')
                    : null}
                </span>
              </h2>
              <div className="total-gpa">
                <InputMask
                  type="text"
                  tabIndex={0}
                  onChange={this.onInputChange}
                  value={cumulative_gpa}
                  onBlur={(e) => this.checkValue(e, { min: 0, max: 5 })}
                  maskPlaceholder={null}
                  mask="9.99"
                  placeholder="0.0 - 4.0+"
                  className="form-statistics third"
                  aria-label="total GPA"
                  aria-describedby="cumulative_gpa-error"
                  id="cumulative_gpa"
                  disabled={this.props.location.pathname.includes(
                    'user-profile'
                  )}
                />
                {this.state.error_cumulative_gpa ? (
                  <p
                    aria-live="assertive"
                    role="alert"
                    aria-atomic="true"
                    aria-relevant="text"
                    className="score-error"
                    id="cumulative_gpa-error"
                  >
                    {this.state.error_cumulative_gpa}
                  </p>
                ) : null}
              </div>
            </div>
            <div className="statistics-section">
              <div className="gpa-container">
                <div className="left-scores">
                  {this.score(psat, 'PSAT', 'psat', '320-1520', 1520, 320)}
                  {this.score(sat, 'SAT', 'sat', '400-1600', 1600, 400)}
                </div>
                <div className="right-scores">
                  {this.score(act, 'ACT', 'act', '1-36', 36, 1)}
                  {this.score(
                    class_rank,
                    'Class Rank',
                    'class_rank',
                    '1-100+',
                    100000,
                    1
                  )}
                </div>
              </div>
              <div className="underline" />
            </div>

            {this.props.location.pathname.includes('user-profile') ? (
              <div className="statistics-section">
                <h2 className="header-additional-info">
                  {t('Additional Information')}
                </h2>
                <div className="additional-info-label" style={primaryColor}>
                  {t('Student Number: ')}
                  <span className="additional-info">
                    {student_number.length > 0
                      ? student_number
                      : t('No information entered')}
                  </span>
                </div>
                <div className="additional-info-label" style={primaryColor}>
                  {t('Counselor or Mentor Name: ')}
                  <span className="additional-info">
                    {counselor_name.length > 0
                      ? counselor_name
                      : t('No information entered')}
                  </span>
                </div>
                <div className="additional-info-label" style={primaryColor}>
                  {t('Counselor or Mentor Email: ')}
                  <span className="additional-info">
                    {counselor_email.length > 0
                      ? counselor_email
                      : t('No information entered')}
                  </span>
                </div>
                <div className="additional-info-label" style={primaryColor}>
                  {t('Parent or Guardian Name: ')}
                  <span className="additional-info">
                    {parent_name.length > 0
                      ? parent_name
                      : t('No information entered')}
                  </span>
                </div>
                <div className="additional-info-label" style={primaryColor}>
                  {t('Parent or Guardian Email: ')}
                  <span className="additional-info">
                    {parent_email.length > 0
                      ? parent_email
                      : t('No information entered')}
                  </span>
                </div>
              </div>
            ) : (
              <div className="statistics-section bottom">
                <label
                  className="label-info"
                  htmlFor="studentNumber"
                  style={primaryColor}
                >
                  {t('Additional Information')}
                </label>
                <div className="container-for-student-number">
                  {this.contactInfo(
                    student_number,
                    t('Student Number (optional)'),
                    'student_number'
                  )}
                </div>
                <div className="additional-info-container">
                  {this.contactInfo(
                    counselor_name,
                    t('Counselor or Mentor Name (optional)'),
                    'counselor_name'
                  )}
                  {this.contactInfo(
                    counselor_email,
                    t('Counselor or Mentor Email (optional)'),
                    'counselor_email'
                  )}
                  {this.contactInfo(
                    parent_name,
                    t('Parent or Guardian Name: '),
                    'parent_name'
                  )}
                  {this.contactInfo(
                    parent_email,
                    t('Parent or Guardian Email: '),
                    'parent_email'
                  )}
                </div>
              </div>
            )}
            {!this.props.location.pathname.includes('user-profile') && (
              <div className="submit-button-container">
                <button
                  aria-label={t('Save your progress and continue')}
                  type="submit"
                  className={['button--primary', this.getDynamicButton()].join(
                    ' '
                  )}
                  id="submit-button-stats"
                  onClick={async () => {
                    this.handleRoutingGTM();
                    await this.submitPlan();
                    this.props.scrollNext();
                  }}
                  onKeyDown={async (e) => {
                    if (['Enter'].includes(e.key)) {
                      this.handleRoutingGTM();
                      await this.submitPlan();
                      this.props.scrollNext();
                    }
                  }}
                >
                  {t('Continue')}
                </button>
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const ecap = getEcapState(state);
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  return { ecap, auth, onboarding };
};

const AcademicStatisticsWithRouter = withRouter(
  connect(mapStateToProps, {
    getEcap,
    saveEcap,
    setEcap,
  })(withStyles(continueButtonStyles)(AcademicStatistics))
);

export default AcademicStatisticsWithRouter;
